import React, { createContext, useContext, useState } from 'react';
import { useAppContext } from './AppContext';
import RowDetailsModal from '../components/CustomModal/RowDetailsModal';

// context delaration
const pageContext = createContext({
  // eslint-disable-next-line
  customFieldName: (defaultLabel) => {
    return '';
  },
});

export const PageContextProvider = ({ children }) => {
  const { getPageCustomFieldName } = useAppContext();
  const [rowDetailsModal, setRowDetailsModal] = useState({
    data: {},
    open: false,
  });

  const customFieldName = (defaultLabel) => {
    const componentName = children?.props?.componentName || '';
    return getPageCustomFieldName(defaultLabel, componentName);
  };

  const getPageComponentName = () => {
    return children?.props?.componentName || '';
  };

  const openRowDetailsModal = (data, title, renderRowDetailsAddOnButtons) => {
    setRowDetailsModal({
      title: title,
      open: true,
      data: data,
      renderRowDetailsAddOnButtons,
    });
  };

  return (
    <pageContext.Provider
      value={{
        customFieldName,
        getPageComponentName,
        openRowDetailsModal,
      }}
    >
      {children}
      <RowDetailsModal
        {...rowDetailsModal}
        onClose={() => {
          setRowDetailsModal({
            open: false,
            data: {},
          });
        }}
      />
    </pageContext.Provider>
  );
};

// custom hook to use the appContext and access global application data
export const usePageContext = () => useContext(pageContext);
